import React from 'react';

import StudyCounters from '../../StudyList/StudyCounters';

class StudyFavoriteQuestions extends React.Component {
  render() {
    const { counterFavorite } = this.props;
    const classes =
      'd-flex list-group-item flex-row align-items-center justify-content-between cursor-pointer';
    return (
      <ul className="ulStyle">
        <li
          className={classes}
          onClick={() => {
            if (this.props.otherUsersQuestions) {
              this.props.history('/app/question/studyFavoriteQuestion');
            } else {
              this.props.history('/app/question/studyMyFavoriteQuestion');
            }
          }}
          data-test="study-my-favorited-questions-button"
        >
          <div className="titleAndNeedPub">
            <div className="d-flex flex-row align-items-center list-title ">
              <span className="d-flex ml-2 mr-2">
                {' '}
                {this.props.otherUsersQuestions
                  ? 'STUDY ALL FAVORITE QUESTIONS IN MY AFSC'
                  : 'STUDY MY FAVORITED QUESTIONS'}
              </span>
            </div>
          </div>
          <StudyCounters
            id={16239}
            reviewWhen={null}
            new={counterFavorite?.new ?? 0}
            learning={counterFavorite?.learning ?? 0}
            review={counterFavorite?.review ?? 0}
            favorite
          />
        </li>
      </ul>
    );
  }
}

export default StudyFavoriteQuestions;
